import React from 'react'
import PreviewTextFieldSkeleton from '../PreviewTextFieldSkeleton'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import SkeletonAdMediaThumbnail from '../SkeletonAdMediaThumbnail'
import SkeletonActionButton from '../ActionButton/Skeleton'
import SkeletonDescriptionText from '../DescriptionText/Skeleton'
import SkeletonHeadlineText from '../HeadlineText/Skeleton'
import SkeletonWebsiteText from '../WebsiteText/SkeletonWebsiteText'
import AvatarSkeleton from '../Avatar/AvatarSkeleton'

import useAdCardSingleStyles, {
  singleAdThumbnailHeight
} from '../../FacebookSingleMediaAdPreview/FacebookSingleMediaAdFooter/styles'
import useActionButtonStyles from '../ActionButton/styles'
import usePreviewContainerStyles from '../FacebookAdPreviewContainer/styles'
import usePageNameStyles from '../PageName/styles'
import usePrimaryTextStyles from '../AdPrimaryText/styles'
import useStyles from '../FacebookAdPreviewHeader/styles'
import useWebsiteStyles from '../WebsiteText/styles'

function FacebookAdPreviewSkeleton({ className, renderFooterContent = true }) {
  const { t } = useTranslation()

  const facebookAdPreviewContainerClasses = usePreviewContainerStyles()
  const pageNameClasses = usePageNameStyles()
  const classes = useStyles()
  const classesActionButton = useActionButtonStyles()
  const classesAdCardSingle = useAdCardSingleStyles()
  const primaryTextClasses = usePrimaryTextStyles()
  const websiteClasses = useWebsiteStyles()

  return (
    <div className={classnames(facebookAdPreviewContainerClasses.adCard, className)}>
      <div className={classes.adCardHeader}>
        <div className={classes.headerTop}>
          <AvatarSkeleton />
          <div className={classes.info}>
            <div className={classes.name}>
              <PreviewTextFieldSkeleton
                isInProgress={false}
                count={1}
                className={pageNameClasses.skeletonPageName}
                showLoadingAnimation
              />
            </div>
            <div className={classes.description}>{t('Sponsored')}</div>
          </div>
        </div>
        <div className={classes.adText}>
          <PreviewTextFieldSkeleton
            isInProgress={false}
            count={3}
            className={primaryTextClasses.skeletonPrimaryText}
            showLoadingAnimation
          />
        </div>
      </div>
      <SkeletonAdMediaThumbnail mediaPreviewHeight={singleAdThumbnailHeight} />
      {renderFooterContent && (
        <div className={classesAdCardSingle.adFooter}>
          <div className={classesAdCardSingle.footerInfo}>
            <div className={classesAdCardSingle.footerWebsite}>
              <SkeletonWebsiteText
                isInProgress={false}
                count={1}
                className={websiteClasses.skeletonWebsiteText}
                showLoadingAnimation
              />
            </div>
            <div className={classesAdCardSingle.singleHeadlineText}>
              <SkeletonHeadlineText
                isInProgress={false}
                count={1}
                className={classesAdCardSingle.skeletonSingleHeadline}
                showLoadingAnimation
              />
            </div>
            <div className={classesAdCardSingle.singleDescriptionText}>
              <SkeletonDescriptionText isInProgress={false} showLoadingAnimation />
            </div>
          </div>
          <div className={classnames(classesActionButton.actionButton, classesAdCardSingle.singleContentActionButton)}>
            <SkeletonActionButton isInProgress={false} showLoadingAnimation />
          </div>
        </div>
      )}
    </div>
  )
}

FacebookAdPreviewSkeleton.propTypes = {
  className: PropTypes.string,
  renderFooterContent: PropTypes.bool
}

export default FacebookAdPreviewSkeleton
